import React, { Fragment } from 'react';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGrid = ({ state }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Legal Entity Name</th>
        <th>Legal Entity Tax Id</th>
      </tr>
    </thead>
    <tbody>
      {state.isObjLoaded !== true
        ? (
          <tr>
            {state.isObjLoading === true
              ? <td colSpan="2">Loading...</td>
              : <td colSpan="2">No Legal Entities</td>}
          </tr>
        ) : Array.isArray(state.objData.usasClubLegalEntities) && state.objData.usasClubLegalEntities.length > 0
          ? state.objData.usasClubLegalEntities.map(entity => (
            <tr key={entity.usasClubLegalEntityId}>
              <td>{entity.legalEntityName}</td>
              <td>{entity.legalEntityTaxId}</td>
            </tr>))
          : (
            <tr>
              <td colSpan="2">No Legal Entities</td>
            </tr>
          )}
    </tbody>
  </table>
);

const SmallGrid = ({ state }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {state.isObjLoaded !== true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            {state.isObjLoading === true
              ? <div className={global.SmallTableRowLabels}>Loading...</div>
              : <div className={global.SmallTableRowLabels}>No Legal Entities</div>
            }
          </div>
        </div>)
      : Array.isArray(state.objData.usasClubLegalEntities) && state.objData.usasClubLegalEntities.length > 0
        ? state.objData.usasClubLegalEntities.map(entity => (
          <div className={global.SmallTableRow} key={entity.usasClubLegalEntityId}>
            <div className={global.SmallTableRowHead}><span className='hidden-xs'>{entity.legalEntityName}</span>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className='row'>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Legal Entity Name</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{entity.legalEntityName}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Legal Entity Tax Id</div>
                <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>{entity.legalEntityTaxId}</div>
              </div>
            </div>
          </div>))
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Legal Entities</div>
            </div>
          </div>
        )}
  </div >
);

const ClubLegalEntitiesReadGrid = ({ state }) => (
  <Fragment>
    <LargeGrid state={state} />
    <SmallGrid state={state} />
  </Fragment>
);

export default ClubLegalEntitiesReadGrid;